<template>
    <div class="main">
      <a-form-model class="user-layout-login" @keyup.enter.native="handleSubmit">
        <login-account ref="alogin" @validateFail="validateFail" @success="requestSuccess" @fail="requestFailed"></login-account>
  
        <!-- <a-form-model-item>
          <a-checkbox @change="handleRememberMeChange" default-checked>自动登录</a-checkbox>
          <router-link :to="{ name: 'alteration'}" class="forge-password" style="float: right;">
            忘记密码
          </router-link>
          <router-link :to="{ name: 'register'}" class="forge-password" style="float: right;margin-right: 10px" >
            注册账户
          </router-link>
        </a-form-model-item> -->
  
        <a-form-item style="margin-top:24px">
          <a-button size="large"  type="primary"  htmlType="submit"  class="login-button"  :loading="loginBtn"  @click.stop.prevent="handleSubmit" :disabled="loginBtn"> {{ $t('antd.table.ensure') }}
          </a-button>
        </a-form-item>
  
      </a-form-model>
    </div>
  </template>
  
  <script>
  import LoginAccount from './login-account'
  
  export default {
      components: {
        LoginAccount
      },
      data () {
        return {
          customActiveKey: 'tab1',
          rememberMe: true,
          loginBtn: false,
          stepCaptchaVisible: false,
          encryptedString:{
            key:"",
            iv:"",
          },
        }
      },
      created() {
      
        this.getRouterData();
        this.rememberMe = true
      },
      methods:{
        handleTabClick(key){
          this.customActiveKey = key
        },
        handleRememberMeChange(e){
          this.rememberMe = e.target.checked
        },
        /**跳转到登录页面的参数-账号获取*/
        getRouterData(){
          this.$nextTick(() => {
            let temp = this.$route.params.username || this.$route.query.username || ''
            if (temp) {
              this.$refs.alogin.acceptUsername(temp)
            }
          })
        },
  
        //登录
        handleSubmit () {
          this.loginBtn = true;
          if (this.customActiveKey === 'tab1') {
            // 使用账户密码登录
            this.$refs.alogin.handleLogin(this.rememberMe)
          } else {
            //手机号码登录
            this.$refs.plogin.handleLogin(this.rememberMe)
          }
        },
        // 校验失败
        validateFail(){
          this.loginBtn = false;
        },
        // 登录后台成功
        requestSuccess(){
          // this.$refs.loginSelect.show(loginResult)
          this.loginSuccess()
        },
        //登录后台失败
        requestFailed (err) {
          let description = ((err.response || {}).data || {}).message || err.message || "请求出现错误，请稍后再试"
          this.$notification[ 'error' ]({
            message: '登录失败',
            description: description,
            duration: 4,
          });
          //账户密码登录错误后更新验证码
          if(this.customActiveKey === 'tab1' && description.indexOf('密码错误')>0){
            this.$refs.alogin.handleChangeCheckCode()
          }
          this.loginBtn = false;
        },
        loginSelectOk(){
          this.loginSuccess()
        },
        //登录成功
        loginSuccess () {
          this.$router.push({ path: "/dashboard/analysis" }).catch(()=>{
            console.log('登录跳转首页出错,这个错误从哪里来的')
          })
          this.$notification.success({
            message: this.$t('homeData.hello'),
            description: this.$t('homeData.welcome'),
          });
        },
  
        stepCaptchaSuccess () {
          this.loginSuccess()
        },
        stepCaptchaCancel () {
          this.Logout().then(() => {
            this.loginBtn = false
            this.stepCaptchaVisible = false
          })
        }
      }
    }
  </script>
  <style lang="less" scoped>
    .user-layout-login {
      label {
        font-size: 14px;
      }
    .getCaptcha {
        display: block;
        width: 100%;
        height: 40px;
      }
  
    .forge-password {
        font-size: 14px;
      }
  
      button.login-button {
        padding: 0 15px;
        font-size: 16px;
        height: 40px;
        width: 100%;
      }
  
    .user-login-other {
        text-align: left;
        margin-top: 24px;
        line-height: 22px;
  
      .item-icon {
          font-size: 24px;
          color: rgba(0,0,0,.2);
          margin-left: 16px;
          vertical-align: middle;
          cursor: pointer;
          transition: color .3s;
  
        &:hover {
            color: #1890ff;
          }
        }
  
      .register {
          float: right;
        }
      }
    }
  </style>
  <style>
    .valid-error .ant-select-selection__placeholder{
      color: #f5222d;
    }
  </style>